import { Audio, InterruptionModeAndroid, InterruptionModeIOS } from 'expo-av';
import { useEffect } from 'react';

// call this once at the beginning of the app to set up audio
export default function useSetupAudio() {
  useEffect(() => {
    const setupAudioMode = async () => {
      try {
        await Audio.setAudioModeAsync({
          allowsRecordingIOS: false,
          interruptionModeIOS: InterruptionModeIOS.DoNotMix,
          playsInSilentModeIOS: true, // Ensures sound plays even if device is on silent
          shouldDuckAndroid: true,
          staysActiveInBackground: false,
          interruptionModeAndroid: InterruptionModeAndroid.DoNotMix,
          playThroughEarpieceAndroid: false, // Ensure sound plays through speaker instead of earpiece
        });
      } catch (error) {
        console.error('Error setting audio mode:', error);
      }
    };

    void setupAudioMode();
  }, []);
}
